import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const BACKEND_URL = "http://127.0.0.1:8000";

export const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("verifying"); // verifying | success | error

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    axios.get(`${BACKEND_URL}/api/v1/auth/verify-email?token=${token}`)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [token]);

  if (status === "verifying") return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-accent mx-auto mb-4" />
        <p className="text-muted-foreground">Verifying your email…</p>
      </div>
    </div>
  );

  if (status === "success") return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>
        <h1 className="font-heading text-3xl font-bold mb-4">Email Verified!</h1>
        <p className="text-muted-foreground mb-8">
          Your email has been confirmed. Our team is now reviewing your business
          application. You will receive an email once your account is approved.
        </p>
        <Button onClick={() => navigate("/login")}
          className="bg-accent hover:bg-accent-hover text-white px-8">
          Back to Login
        </Button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-red-500" />
        </div>
        <h1 className="font-heading text-3xl font-bold mb-4">Invalid Link</h1>
        <p className="text-muted-foreground mb-8">
          This verification link is invalid or has already been used.
          Please contact support if you need help.
        </p>
        <Button variant="outline" onClick={() => navigate("/")}>Go Home</Button>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
